import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { get, isFunction } from 'lodash-es';

export const getActionNameString = (actionName) => {
	// ActionName must be a valid string or ActionCreator function
	if (!actionName) {
		return '';
	} else if (isFunction(actionName.toString)) {
		return actionName.toString();
	} else if (typeof actionName === 'string') {
		return actionName;
	}

	return '';
};

export const INVALID_ACTION_TYPE_ERROR =
	'Invalid value for action name. Value provided must be an ActionCreator function or string';

const Actions = {
	setActionError: 'setActionError',
	resetActionError: 'resetActionError',
};

// Actions
export const setActionError = createAction(Actions.setActionError);
export const resetActionError = createAction(Actions.resetActionError);

// Selectors
const getActionErrorData = (state) => {
	const actionErrorData = get(state, 'actionError', {});
	return actionErrorData;
};

// for react > 18 createSelector is required to create memoized selectors so as to prevent unnecessary re-renders
export const getActionError = createSelector(
	[getActionErrorData, (_, actionName) => actionName],
	(actionErrorData, actionName) => {
		const actionNameString = getActionNameString(actionName);
		const error = get(actionErrorData, actionName, {});
		return actionNameString ? error : {};
	},
);

const initialState = {};

export default createReducer(initialState, (builder) => {
	builder.addCase(setActionError, (state, action) => {
		const actionName = get(action, 'payload.actionName', false);
		const actionNameString = getActionNameString(actionName);
		if (!actionNameString) {
			throw new Error(INVALID_ACTION_TYPE_ERROR);
		}
		const isFetchFailed = get(action, 'payload.isFetchFailed', false);
		const isUploadFailed = get(action, 'payload.isUploadFailed', false);
		const message = get(action, 'payload.message', false);
		state[actionNameString] = {
			isFetchFailed,
			isUploadFailed,
			message,
		};
	});
	builder.addCase(resetActionError, (state, action) => {
		const actionName = action.payload;
		const actionNameString = getActionNameString(actionName);

		if (actionNameString) {
			delete state[actionNameString];
		}
	});
});
